import React from "react";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container text-center">
        © Shri Ghanamatheshwar College of Education (B.Ed.) | All Rights Reserved
      </div>
    </footer>
  );
}
